<template>
  <div class="grid grid-cols-2 gap-4">
    <button
      type="button"
      class="bg-background text--md text-primary hover:text-primary-hover active:text-primary-pressed py-3 rounded-[15px]"
    >
      $ USD
    </button>
    <button
      type="button"
      class="bg-background text--md text-primary hover:text-primary-hover active:text-primary-pressed py-3 rounded-[15px] uppercase flex gap-2 justify-center items-center"
      @click="$emit('open-language-menu')"
    >
      {{ $i18n.locale }}
      <i-mdi-web class="text-[29px]" />
    </button>
  </div>
</template>

<script setup>
defineEmits({
  "open-language-menu": null,
});
</script>

<style lang="scss" scoped></style>
